import { createStore } from 'vuex'
import timelineModule from './timeline'
import loginModule from './login'
import optionsModule from './options'
import flightsModule from './flights'
import passengersModule from './passengers'
import revisionModule from './revision'
import cancellationModule from './cancellation'

export default createStore({
  modules: {
    timelineModule: timelineModule,
    loginModule: loginModule,
    optionsModule: optionsModule,
    flightsModule: flightsModule,
    passengersModule: passengersModule,
    revisionModule: revisionModule,
    cancellationModule: cancellationModule,
  },
  state() {
    return {}
  },
  mutations: {},
  actions: {}
})